// extracted by mini-css-extract-plugin
module.exports = {"font":"Font_font__1g__9","styleDetails":"Font_styleDetails__2jqsa","fontDetails":"Font_fontDetails__3ZqLN","plusCircle":"Font_plusCircle__sTd6q"};